import { IconProps } from "./types";

export const SearchIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M5.83944 0.822266C9.07272 0.822266 11.687 3.41547 11.687 6.62264C11.687 7.76979 11.3368 8.83615 10.7504 9.71671L13.6254 12.5846C13.8778 12.835 14 13.1662 14 13.5136C14 14.2568 13.438 14.8223 12.6806 14.8223C12.3223 14.8223 11.9884 14.7012 11.7277 14.4507L8.82024 11.5667C7.9651 12.0999 6.93892 12.4069 5.83944 12.4069C2.61431 12.4069 0 9.81365 0 6.61456C0 3.41547 2.61431 0.822266 5.83944 0.822266ZM5.83944 10.6296C8.07097 10.6296 9.879 8.83615 9.879 6.62264C9.879 4.40913 8.07912 2.6157 5.83944 2.6157C3.59977 2.6157 1.79988 4.4172 1.79988 6.62264C1.79988 8.82807 3.60791 10.6296 5.83944 10.6296Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
